export function normalizeNumberIds(ids: number[] | null | undefined): number[] {
    const deduped = Array.from(new Set((ids || []).filter((v) => typeof v === 'number')));
    return deduped.sort((a, b) => a - b);
}

export function areNumberArraysEqual(a: number[] | null | undefined, b: number[] | null | undefined): boolean {
    if (a === b) return true;
    if (!a || !b) return false;
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

export function areArraysShallowEqual<T>(
    a: ReadonlyArray<T> | null | undefined,
    b: ReadonlyArray<T> | null | undefined
): boolean {
    if (a === b) return true;
    if (!a || !b) return false;
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}


